import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';

import { AuthenicationService } from "../../_services/authenication.service";
import {UserService} from '../../_services/user.service';
import {ToasterService} from "../../_services/toaster.service";
import { MustMatch } from '../../_helpers/must-match.validator';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent implements OnInit {

  changePasswordForm: FormGroup;
  userdetaild: any;
  submitted = false;
  returnUrl: string;
  userid: any;
  forOthers = false;


  constructor(private formBuilder: FormBuilder,private router: Router, private route: ActivatedRoute, private authenicationService: AuthenicationService, private toaster: ToasterService, private userservice: UserService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee3') {
      this.router.navigate(['/']);
    }

    this.route.queryParams.subscribe(params => {
      this.userid = params['did'] || this.userdetaild['_id'];
      this.forOthers = !!(params['did']);
    });

    //this.userid = this.userdetaild['_id'];

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    if (this.forOthers){
      this.changePasswordForm = this.formBuilder.group({
        new_password: ['', [Validators.required, Validators.minLength(6)]],
        c_new_password: ['', [Validators.required, Validators.minLength(6)]]
      }, {
        validator: MustMatch('new_password', 'c_new_password')
      });
    }else {
      this.changePasswordForm = this.formBuilder.group({
        old_password: ['', [Validators.required]],
        new_password: ['', [Validators.required, Validators.minLength(6)]]
      });
    }
  }
  get f() { return this.changePasswordForm.controls; }

  onSubmitChangePassword(){
    this.submitted = true;
    // stop here if form is invalid
    if (this.changePasswordForm.invalid) {
      return;
    }
    if (this.forOthers){
      const passwordPayload = {
        userid: this.userid,
        new_password: this.changePasswordForm.controls.new_password.value
      };
     // console.log(passwordPayload);
      this.changeUserPassword(passwordPayload)
    }else{
      const passwordPayload = {
        userid: btoa(btoa(this.userid)),
        old_password: btoa(btoa(this.changePasswordForm.controls.old_password.value)),
        new_password: btoa(btoa(this.changePasswordForm.controls.new_password.value))
      };
      this.changePassword(passwordPayload);
    }


  }

  logout() {
    this.authenicationService.logout();
    this.router.navigateByUrl('/login');
  }

  changePassword(payload) {
    this.userservice.changePassword(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            //alert(data.ResponseMessage);
            this.logout();
          } else {
            this.toaster.showError('Change Password', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          //alert(error.error.ResponseMessage);
          this.toaster.showError('Update Doctor', error.error.ResponseMessage);
        });
  }

  changeUserPassword(payload) {
    this.userservice.updateUserPassword(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.router.navigate(['/doctorlist']);
          } else {
            this.toaster.showError('Change Password', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          //alert(error.error.ResponseMessage);
          this.toaster.showError('Change Password', error.error.ResponseMessage);
        });
  }

}
